
<template>
<section id="natureLynxSection" class="section bgDarkest pretty-"  v-if="hasNLSighting">

  <div class="sectionBg dimLess homeHeader"></div>

  <div class="container">

    <h2 class="has-text-centered">{{ $t("profile.aboutSpp.natureLynx.header") }}</h2>
    <p class="has-text-centered caps citizen-link"> {{ $t("profile.aboutSpp.natureLynx.link") }}</p>

    <div class="columns is-multiline is-centered">
      <template v-if="hasNLSighting">
        <div class="column is-6-tablet is-3-desktop" v-for="(item, index) in sightings" :key="'sighting' + index">
          <div class="card">
            <div class="card-image">
              <div class="squareImg objectFit">
                <photo-images :paths="item.path"/>
              </div>
            </div>
            <div class="card-content">
              <div class="content">
                <time v-show="false" datetime="2016-1-1">11:09 PM - 1 Jan 2016</time>
                <div class="media">
                  <div class="media-left">
                    <svg class="naturelynx-logo">
                      <use xlink:href="@/assets/sprite.svg#icon-naturelynx"></use>
                    </svg>
                  </div>
                  <div class="media-content">
                    <p><strong>{{item?.credit}}</strong><br>
                    </p>
                  </div>
                </div>
                <div class="card-footer" v-show="false">
                  <p>Sample Foot Text</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <p class="center" v-html='$t("profile.aboutSpp.natureLynx.noSighting", {sppName: state?.sppName})'></p>
      </template>
    </div>
  </div>
</section>

</template>

<script setup>
import { computed } from 'vue';
import { useApp } from '@/composables/state/profileState';
import PhotoImages from '../../../components/biobrowser/PhotoImages.vue';

const { photoCollection, hasNLSighting } = useApp();
// const natureLynxUrl = import.meta.env.VITE_APP_NATURE_LYNX_URL
const sightings = computed(() => {
  return photoCollection.naturelynx.slice(0, 4);
})

</script>

<style scoped>
.naturelynx-logo {
  width: 24px;
  height: 24px;
}
.section {
  padding-bottom: 100px;
  padding-top: 80px;
}
.citizen-link {
  color: #a7b452;
  font-family: Montserrat,sans-serif;
}
</style>
